export const Poliester1 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.06322 7.75L6.66738 6.3125V11.25C6.37572 11.2778 6.091 11.3231 5.81322 11.3858C5.53544 11.4486 5.26461 11.5353 5.00072 11.6458V9.14583L4.14655 9.60417C3.95211 9.71528 3.74377 9.73972 3.52155 9.6775C3.29933 9.61528 3.13266 9.48667 3.02155 9.29167L1.35488 6.39583C1.24377 6.20139 1.21933 5.98972 1.28155 5.76083C1.34377 5.53194 1.47238 5.36167 1.66738 5.25L5.81322 2.85417C5.97988 2.75694 6.1535 2.67361 6.33405 2.60417C6.51461 2.53472 6.70211 2.5 6.89655 2.5C7.091 2.5 7.25766 2.55917 7.39655 2.6775C7.53544 2.79583 7.63961 2.945 7.70905 3.125C7.9035 3.65278 8.15711 4.09722 8.46988 4.45833C8.78266 4.81944 9.29294 5 10.0007 5C10.7091 5 11.2196 4.81944 11.5324 4.45833C11.8452 4.09722 12.0985 3.65278 12.2924 3.125C12.3618 2.94444 12.4696 2.79528 12.6157 2.6775C12.7618 2.55972 12.9318 2.50056 13.1257 2.5C13.3202 2.5 13.5043 2.53472 13.6782 2.60417C13.8521 2.67361 14.0221 2.75694 14.1882 2.85417L18.334 5.25C18.5285 5.36111 18.6535 5.52778 18.7091 5.75C18.7646 5.97222 18.7368 6.18056 18.6257 6.375L16.9799 9.29167C16.8688 9.48611 16.7021 9.61472 16.4799 9.6775C16.2577 9.74028 16.0493 9.71583 15.8549 9.60417L15.0007 9.14583V13.1458L13.6882 14.2917C13.6327 14.3333 13.5771 14.3717 13.5216 14.4067C13.466 14.4417 13.4035 14.4728 13.3341 14.5V6.3125L15.9382 7.75L16.7716 6.29167L13.5841 4.4375C13.2507 5.11806 12.761 5.65972 12.1149 6.0625C11.4688 6.46528 10.7641 6.66667 10.0007 6.66667C9.23683 6.66667 8.53183 6.46528 7.88572 6.0625C7.23961 5.65972 6.75016 5.11806 6.41738 4.4375L3.20905 6.29167L4.06322 7.75ZM3.33405 15.5208C3.18127 15.3403 3.11516 15.1353 3.13572 14.9058C3.15627 14.6764 3.25711 14.4856 3.43822 14.3333L4.60488 13.3333C4.92433 13.0556 5.28905 12.8436 5.69905 12.6975C6.10905 12.5514 6.536 12.4786 6.97988 12.4792C7.42433 12.4792 7.84794 12.5522 8.25072 12.6983C8.6535 12.8444 9.01461 13.0561 9.33405 13.3333L11.7507 15.3958C11.9174 15.5347 12.1154 15.6425 12.3449 15.7192C12.5743 15.7958 12.8068 15.8339 13.0424 15.8333C13.2924 15.8333 13.5252 15.7986 13.7407 15.7292C13.9563 15.6597 14.1471 15.5486 14.3132 15.3958L15.4799 14.3958C15.6604 14.2431 15.8654 14.1736 16.0949 14.1875C16.3243 14.2014 16.5152 14.2986 16.6674 14.4792C16.8202 14.6597 16.8863 14.8647 16.8657 15.0942C16.8452 15.3236 16.7443 15.5144 16.5632 15.6667L15.3966 16.6667C15.0771 16.9444 14.716 17.1528 14.3132 17.2917C13.9104 17.4306 13.4868 17.5 13.0424 17.5C12.5979 17.5 12.1707 17.4306 11.7607 17.2917C11.3507 17.1528 10.9863 16.9444 10.6674 16.6667L8.25072 14.6042C8.08405 14.4653 7.89294 14.3575 7.67738 14.2808C7.46183 14.2042 7.22961 14.1661 6.98072 14.1667C6.74461 14.1667 6.51183 14.205 6.28238 14.2817C6.05294 14.3583 5.85516 14.4658 5.68905 14.6042L4.50155 15.6042C4.321 15.7569 4.11961 15.8264 3.89738 15.8125C3.67516 15.7986 3.48738 15.7014 3.33405 15.5208Z"
        fill="#59224C"
      />
    </svg>
  );
};

export const Poliester2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M12.5 2.5H16.875V3.75H12.5V2.5ZM12.5 6.25H18.75V7.5H12.5V6.25ZM12.5 10H16.875V11.25H12.5V10ZM7.5 14.375C7.5 14.8723 7.30246 15.3492 6.95083 15.7008C6.59919 16.0525 6.12228 16.25 5.625 16.25C5.12772 16.25 4.65081 16.0525 4.29917 15.7008C3.94754 15.3492 3.75 14.8723 3.75 14.375H7.5Z"
        fill="#59224C"
      />
      <path
        d="M18.7494 13.75H9.94938C9.8165 12.8331 9.39638 11.9819 8.74938 11.3187V4.375C8.74938 3.5462 8.42014 2.75134 7.83409 2.16529C7.24804 1.57924 6.45318 1.25 5.62438 1.25C4.79558 1.25 4.00072 1.57924 3.41467 2.16529C2.82862 2.75134 2.49938 3.5462 2.49938 4.375V11.3187C2.01592 11.8121 1.65624 12.413 1.44981 13.0721C1.24337 13.7313 1.19607 14.43 1.31176 15.111C1.42746 15.7919 1.70286 16.4358 2.1154 16.9898C2.52795 17.5438 3.06589 17.9922 3.68515 18.2982C4.30441 18.6042 4.98736 18.7591 5.67804 18.7502C6.36871 18.7413 7.04746 18.5689 7.65865 18.2471C8.26985 17.9253 8.79609 17.4633 9.19427 16.8989C9.59244 16.3345 9.85122 15.6837 9.94938 15H18.7494V13.75ZM5.62438 17.5C4.99172 17.5009 4.37372 17.3095 3.85233 16.9512C3.33094 16.5928 2.93078 16.0844 2.70491 15.4935C2.47904 14.9025 2.43813 14.2568 2.58761 13.6421C2.73708 13.0273 3.06988 12.4725 3.54188 12.0512L3.74938 11.8644V4.375C3.74938 3.87772 3.94692 3.40081 4.29855 3.04917C4.65018 2.69754 5.1271 2.5 5.62438 2.5C6.12166 2.5 6.59857 2.69754 6.9502 3.04917C7.30183 3.40081 7.49938 3.87772 7.49938 4.375V11.8644L7.70688 12.0512C8.17887 12.4725 8.51167 13.0273 8.66115 13.6421C8.81062 14.2568 8.76971 14.9025 8.54385 15.4935C8.31798 16.0844 7.91782 16.5928 7.39643 16.9512C6.87504 17.3095 6.25704 17.5009 5.62438 17.5Z"
        fill="#59224C"
      />
    </svg>
  );
};

export const Poliester3 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_647_1543)">
        <path
          d="M9.16667 18.3332C12.8486 18.3332 15.8333 15.7215 15.8333 12.4998C15.8333 9.27818 12.8486 6.6665 9.16667 6.6665C5.48477 6.6665 2.5 9.27818 2.5 12.4998C2.5 15.7215 5.48477 18.3332 9.16667 18.3332Z"
          stroke="#59224C"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.832 10C11.3874 10.0696 12.4987 10.4167 12.9154 12.0833"
          stroke="#59224C"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M3.33268 4.99984C4.25316 4.99984 4.99935 4.25365 4.99935 3.33317C4.99935 2.4127 4.25316 1.6665 3.33268 1.6665C2.41221 1.6665 1.66602 2.4127 1.66602 3.33317C1.66602 4.25365 2.41221 4.99984 3.33268 4.99984Z"
          stroke="#59224C"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.082 6.6665C17.7724 6.6665 18.332 6.10686 18.332 5.4165C18.332 4.72615 17.7724 4.1665 17.082 4.1665C16.3917 4.1665 15.832 4.72615 15.832 5.4165C15.832 6.10686 16.3917 6.6665 17.082 6.6665Z"
          stroke="#59224C"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_647_1543">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Poliester4 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.79167 4.79167L15.2083 15.2083M10 17.5C9.01509 17.5 8.03982 17.306 7.12987 16.9291C6.21993 16.5522 5.39314 15.9997 4.6967 15.3033C4.00026 14.6069 3.44781 13.7801 3.0709 12.8701C2.69399 11.9602 2.5 10.9849 2.5 10C2.5 9.01509 2.69399 8.03982 3.0709 7.12987C3.44781 6.21993 4.00026 5.39314 4.6967 4.6967C5.39314 4.00026 6.21993 3.44781 7.12987 3.0709C8.03982 2.69399 9.01509 2.5 10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10C17.5 11.9891 16.7098 13.8968 15.3033 15.3033C13.8968 16.7098 11.9891 17.5 10 17.5Z"
        stroke="#59224C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Poliester5 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 12.5H10.0083M7.5 5H13.7158C14.3076 5.00004 14.8802 5.21001 15.3317 5.59256C15.7832 5.97511 16.0844 6.50543 16.1817 7.08917L16.6625 9.97583L17.3375 14.03C17.3573 14.1493 17.351 14.2714 17.3189 14.388C17.2868 14.5045 17.2297 14.6127 17.1516 14.705C17.0735 14.7973 16.9762 14.8715 16.8666 14.9224C16.757 14.9733 16.6376 14.9998 16.5167 15H2.5C2.5 13.4529 3.11458 11.9692 4.20854 10.8752C5.30251 9.78125 6.78624 9.16667 8.33333 9.16667H16.5M7.5 12.5H7.50833M12.5 12.5H12.5083"
        stroke="#59224C"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
